/**
 * Sidebar reorder operations — privateIndex writes for sidebar DnD.
 */

import { getDb, getNow } from "./runtime.js"
import { ok, fail } from "./op-types.js"
import type { OpResult } from "./op-types.js"

// ---------------------------------------------------------------------------
// reorderSidebarItem — single item privateIndex write
// ---------------------------------------------------------------------------

export async function reorderSidebarItem(
  id: string,
  newIndex: number,
): Promise<OpResult> {
  const db = getDb()
  try {
    const entryId = `#${id}`
    await db.transaction("rw", [db.totodo, db.privateIndex], async () => {
      await db.privateIndex.put({ id: entryId, index: newIndex })
      await db.totodo.update(id, { updatedAt: getNow() })
    })
    return ok()
  } catch (e) {
    return fail(
      `reorderSidebarItem failed: ${e instanceof Error ? e.message : String(e)}`,
    )
  }
}

// ---------------------------------------------------------------------------
// bulkReorderSidebar — multi-item privateIndex write
// ---------------------------------------------------------------------------

export interface SidebarReorderItem {
  id: string
  newIndex: number
}

export async function bulkReorderSidebar(
  items: SidebarReorderItem[],
): Promise<OpResult> {
  const db = getDb()
  if (items.length === 0) return ok()

  try {
    const timestamp = getNow()

    await db.transaction("rw", [db.totodo, db.privateIndex], async () => {
      for (const item of items) {
        const entryId = `#${item.id}`
        await db.privateIndex.put({ id: entryId, index: item.newIndex })
        await db.totodo.update(item.id, { updatedAt: timestamp })
      }
    })

    return ok()
  } catch (e) {
    return fail(
      `bulkReorderSidebar failed: ${e instanceof Error ? e.message : String(e)}`,
    )
  }
}

// ---------------------------------------------------------------------------
// moveItemToArea — cross-area drag
// ---------------------------------------------------------------------------

export async function moveItemToArea(
  id: string,
  newIndex: number,
): Promise<OpResult> {
  return reorderSidebarItem(id, newIndex)
}
